export default __webpack_public_path__ + "static/media/541.8b3924d2.jpg";